import React from 'react';

import classNames from 'classnames';

import COLORS from '../../../constants/colors.constants';

const CaretLeftIcon = ({
  className,
  fill = COLORS.brand,
  size = 24,
  ...rest
}) => (
  <svg
    className={classNames(className)}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fill}
      d="M16.03 18.78C15.8894 18.9204 15.6988 18.9993 15.5 18.9993C15.3013 18.9993 15.1106 18.9204 14.97 18.78L8.72002 12.53C8.57957 12.3894 8.50068 12.1987 8.50068 12C8.50068 11.8012 8.57957 11.6106 8.72002 11.47L14.97 5.21999C15.1122 5.08751 15.3002 5.01539 15.4945 5.01881C15.6888 5.02224 15.8742 5.10095 16.0116 5.23837C16.1491 5.37578 16.2278 5.56117 16.2312 5.75547C16.2346 5.94977 16.1625 6.13781 16.03 6.27999L10.31 12L16.03 17.72C16.1705 17.8606 16.2494 18.0512 16.2494 18.25C16.2494 18.4487 16.1705 18.6394 16.03 18.78Z"
    />
  </svg>
)

export default CaretLeftIcon;
